import { Menu, MenuItem } from "@mui/material";
import { Settings } from "@mui/icons-material";

interface AppBarDropdownMenuProps {
  anchorEl: null | HTMLElement;
  open: boolean;
  onClose: () => void;
  onSettings: () => void;
}

/**
 * Dropdown menu w AppBar
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko dropdown menu
 */
export default function AppBarDropdownMenu({
  anchorEl,
  open,
  onClose,
  onSettings,
}: AppBarDropdownMenuProps) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      onClick={onClose}
      PaperProps={{
        elevation: 3,
        sx: {
          mt: 1,
          minWidth: 200,
          borderRadius: 0,
          border: `1px solid #eee`,
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MenuItem onClick={onSettings}>
        <Settings sx={{ mr: 2, fontSize: 20 }} />
        Ustawienia konta
      </MenuItem>
    </Menu>
  );
}
